// extracted by mini-css-extract-plugin
export default {"wrapper":"main-11_wrapper__QRD3V","container":"main-11_container__mHzLc","boxTitle":"main-11_boxTitle__ajc0w","boxQnA":"main-11_boxQnA__0U9LV"};